import { render, staticRenderFns } from "./VersionCreate.vue?vue&type=template&id=6fb836ce"
import script from "./VersionCreate.vue?vue&type=script&lang=js"
export * from "./VersionCreate.vue?vue&type=script&lang=js"
import style0 from "./VersionCreate.vue?vue&type=style&index=0&id=6fb836ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports